import { Search } from "./search";


export class SearchInit {
    constructor() {
        this.initMap();
    }

    initMap() {
        new Search();
    }
}
